import React, { useContext } from "react";

import { Preview } from "@creatomate/preview";
import { Button, Icon } from "@culturehq/components";

import { Trans } from "app/utils";

import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";
import { removeSubtitlesElements } from "../../utils";

interface DeleteOptionProps {
  preview: Preview;
}

const DeleteOption: React.FC<DeleteOptionProps> = ({ preview }) => {
  const { data: { subtitles }, handleUpdateData } = useContext(CreatomateContext);

  const handleOnDeleteSubtitles = async () => {
    await removeSubtitlesElements(handleUpdateData, preview, subtitles, true);
    handleUpdateData({ subtitlesOn: false });
  };

  return (
    <ChqModalConfirmDelete
      onAccept={handleOnDeleteSubtitles}
      trigger={(onTrigger: () => void) => (
        <Button
          className="DownloadDp-Option Dropdown-Btn"
          onClick={onTrigger}
        >
          <Icon icon="trash-a-outlined" />
          <Trans>Delete Subtitles</Trans>
        </Button>
      )}
    >
      <Trans>
        Are you sure you would like to delete the subtitles? This will erase
        all the subtitles for this video.
      </Trans>
    </ChqModalConfirmDelete>
  );
};

export default DeleteOption;
